export default __webpack_public_path__ + "static/media/quiz-test.042462e7.svg";